module.exports = __webpack_public_path__ + "static/img/GPTW-2022.816f726.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/GPTW-2022.png
// module id = JwYS
// module chunks = 0